<template>
<div>
<h1>Nueva oferta</h1>
    <form @submit.prevent="postInfo()">
        <label>Tipo de oferta</label>
        <select v-model="selectedType">
           <option v-for="TypeResult in type" :value="TypeResult.id">{{ TypeResult.name }}</option>
        </select>
        <label>Proveedor</label>
        <select v-model="selectedProvider">
            <option v-for="provider in providers" :value='provider.id'>{{ provider.name }}</option>
        </select>
        <label v-if='selectedType == 1'>Cuota</label>
        <input type="text" name="fee" v-model="fee" v-show='selectedType == 1'>
        <label v-if='selectedType == 2'>Dias</label>
        <input type="text" name="days" v-model="days" v-show='selectedType == 2'>
        <label>Porcentaje de comision</label>
        <input type="number" min="0" name="" v-model="comission_percent">
        <label>Porcentaje de descuento</label>
        <input type="number" min="0" name="" v-model="discount_percent">
        <label>Vigencia de la oferta</label>
        <input type="radio" id="indefinida" v-model='validity' value="0">Indefinida
        <input type="radio" id="temporal" v-model='validity' value="1">Temporal
        <label>Fecha de inicio</label>
        <input type="date" v-model="startDate">
        <label>Fecha final</label>
        <input type="date" v-model="due_date">
        <label>Titulo de la oferta</label>
        <input type="text" name="" v-model="title">
        <label>Descripción</label>
        <textarea v-model="description"></textarea>
        <button>Entra al post manin</button>
    </form>
</div>
</template>

<script>
export default {
    data() {
        return {
        title: '',
        description: '',
        startDate: '',
        due_date: '',
        validity: '',
        comission_percent: '',
        discount_percent: '',
        fee: '',
        type: [],
        selectedType: '',
        providers: [],
        selectedProvider: '',
        days: '',
        }
    },
        created() {
            this.getStatus();
            this.getProviders();
        },
        methods: {

        postInfo: function() {
            var data = {}

            data["title"] = this.title;
            data["description"] = this.description;
            data["start_date"] = this.startDate;
            data["due_date"] = this.due_date;
            data["validity"] = this.validity;
            data["comission_percent"] = this.comission_percent;
            data["discount_percent"] = this.discount_percent;
            data["fee"] = this.fee;
            data["days"] = this.days;
            data["type_id"] = this.selectedType;
            data['provider_id'] = this.selectedProvider;

            this.$http({
                emulateJSON: true,
                emulateHTTP: true,
                url: 'http://api.dev/v1/offers',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data,
            }).then(function(response) {
                console.log('Registro creado exitosamente ! ');
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido un error !", "error");
            });
        },
        getStatus: function() {
            this.$http.get('http://api.dev/v1/offer-types').then(response => {
            this.type = response.data;
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
            });
        },
        getProviders: function() {
            this.$http.get('http://api.dev/v1/providers').then(response => {
            this.providers = response.data;
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido un error al cargar los proovedores !", "error");
            });
        },
      },
      computed: {
        deleteData:function(){
            if (this.selectedType == '1'){
                return this.days = ''
            }else{
                return this.fee = ''
            }
        }
    },
    }
</script>


// WEBPACK FOOTER //
// create-offers.vue?68cb9c82